import { Box, CircularProgress, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses } from '@mui/material';
import React, { Component } from 'react';
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let desc = '';

class Ingreso extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            stock: {
                cantidadPallet: '',
                medida: '',
                color: '',
                totalKg: '',
                cantidadPaquete: '',
                peso: '',
                ubicacion: '',
                codigo: '',
            },
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejarEnvioIngresoStock = this.manejarEnvioIngresoStock.bind(this);
    }
    async componentDidMount(){}
    render(){
        return (
            <>
                <h3>Ingreso de Stock</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <br/>
                <Container>
                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                    <Table sx={{minWidth: 700}}>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>CANTIDAD PALLET</StyledTableCell>
                                <StyledTableCell>MEDIDA</StyledTableCell>
                                <StyledTableCell>COLOR</StyledTableCell>
                                <StyledTableCell>TOTAL KGxPLT</StyledTableCell>
                                <StyledTableCell>CANT. PAQ.</StyledTableCell>
                                <StyledTableCell>PESO/PAQ. KG.</StyledTableCell>
                                <StyledTableCell>UBICACION</StyledTableCell>
                                <StyledTableCell>CODIGO</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='cantidadPallet' value={this.state.stock.cantidadPallet} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='medida' value={this.state.stock.medida} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                <StyledTableCell>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='color'  value={this.state.stock.color} onChange={this.manejarCambiosDatos}>
                                        <option value=''></option>
                                        <option value='1' key={'1'}>INCOLORO</option>
                                        <option value='2' key={'2'}>AMBAR</option>
                                    </select>
                                </StyledTableCell>
                                <StyledTableCell>{this.state.stock.totalKg}</StyledTableCell>
                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='cantidadPaquete' value={this.state.stock.cantidadPaquete} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='peso' value={this.state.stock.peso} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='ubicacion' value={this.state.stock.ubicacion} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='codigo' value={this.state.stock.codigo} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <button className="btn btn-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioIngresoStock}>Agregar</button>
                </Container>
            </>
        );
    }
    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const stockActualizado = state.stock;
            if(clave === 'cantidadPaquete'){
                valor = parseFloat(valor);
                if(valor === ''){
                    stockActualizado['totalKg'] = stockActualizado.peso;
                }else{
                    stockActualizado['totalKg'] = stockActualizado.peso * valor;
                }
            }else if(clave === 'peso'){
                valor = parseFloat(valor);
                if(valor === ''){
                    stockActualizado['totalKg'] = stockActualizado.cantidadPaquete;
                }else{
                    stockActualizado['totalKg'] = stockActualizado.cantidadPaquete * valor;
                }
            }
            stockActualizado[clave] = valor;
            return{
                stock: stockActualizado,
            };
        })
    }

    async manejarEnvioIngresoStock(e){
        e.preventDefault();
        const cargaUtil = JSON.stringify([this.state.stock]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_nuevoStock.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito[0],
        })

        if(respuesta[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'LOS DATOS FUERON INGRESADOS CORRECTAMENTE',
            })
        }
    }
};

export default Ingreso;
